// Static translations for the public landing page (IT/EN/DE/FR/ES/ZH)

export const LANGS = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
];

export const translations = {
  it: {
    how_slept: "Come hai dormito?",
    share_experience: "Lascia il commento per ricevere il coupon",
    rating_label: "Valutazione",
    select_rating: "Seleziona una valutazione",
    comment_optional: "Il tuo commento (opzionale)",
    comment_placeholder: "Raccontaci la tua esperienza...",
    submit_review: "Invia Recensione",
    sending: "Invio in corso...",
    gdpr_consent: "Inviando questa recensione acconsenti al trattamento dei tuoi dati personali da parte di {hotel} e Magniflex S.p.A. ai sensi del Regolamento UE 2016/679 (GDPR), esclusivamente per finalità di miglioramento del servizio. I dati non verranno ceduti a terzi. Puoi esercitare i tuoi diritti scrivendo a privacy@magniflex.com.",
    exclusive_offer: "OFFERTA ESCLUSIVA",
    take_home_title: "Vuoi portarlo a casa?",
    take_home_subtitle: "Lascia la tua email e ricevi il codice sconto personale",
    email_label: "La tua email",
    email_placeholder: "nome@esempio.com",
    receive_discount: "Ricevi lo sconto",
    no_thanks: "No grazie",
    error_required_rating: "Seleziona una valutazione",
    error_email: "Inserisci un'email valida",
    coupon_sent_title: "Codice inviato!",
    coupon_sent_subtitle: "Controlla la tua casella email entro qualche minuto",
    your_coupon: "Il tuo codice",
    expires_label: "Scade il",
    thanks_title: "Grazie!",
    thanks_subtitle: "Apprezziamo molto il tuo feedback",
    showcase_kicker: "Il materasso che hai dormito in hotel",
    from_price: "A partire da",
    free_shipping: "Consegna gratuita in Italia",
    discover_buy: "Scopri e acquista",
    all_sizes_note: "Disponibile in tutte le misure · Prodotto in Italia · Garanzia 10 anni",
    sleep_pleasure: "Sleep is Life's Greatest Pleasure",
    select_language: "Lingua",
  },
  en: {
    how_slept: "How did you sleep?",
    share_experience: "Leave a comment to receive your coupon",
    rating_label: "Rating",
    select_rating: "Please select a rating",
    comment_optional: "Your comment (optional)",
    comment_placeholder: "Tell us about your experience...",
    submit_review: "Submit Review",
    sending: "Sending...",
    gdpr_consent: "By submitting this review you consent to the processing of your personal data by {hotel} and Magniflex S.p.A. under EU Regulation 2016/679 (GDPR), solely for service improvement purposes. Data will not be shared with third parties. You can exercise your rights by writing to privacy@magniflex.com.",
    exclusive_offer: "EXCLUSIVE OFFER",
    take_home_title: "Want to take it home?",
    take_home_subtitle: "Leave your email and receive your personal discount code",
    email_label: "Your email",
    email_placeholder: "name@example.com",
    receive_discount: "Get the discount",
    no_thanks: "No thanks",
    error_required_rating: "Please select a rating",
    error_email: "Please enter a valid email",
    coupon_sent_title: "Code sent!",
    coupon_sent_subtitle: "Check your inbox within a few minutes",
    your_coupon: "Your code",
    expires_label: "Expires on",
    thanks_title: "Thank you!",
    thanks_subtitle: "We truly appreciate your feedback",
    showcase_kicker: "The mattress you slept on at the hotel",
    from_price: "From",
    free_shipping: "Free shipping in Italy",
    discover_buy: "Discover and buy",
    all_sizes_note: "Available in all sizes · Made in Italy · 10-year warranty",
    sleep_pleasure: "Sleep is Life's Greatest Pleasure",
    select_language: "Language",
  },
  de: {
    how_slept: "Wie haben Sie geschlafen?",
    share_experience: "Hinterlassen Sie einen Kommentar, um Ihren Gutschein zu erhalten",
    rating_label: "Bewertung",
    select_rating: "Bitte wählen Sie eine Bewertung",
    comment_optional: "Ihr Kommentar (optional)",
    comment_placeholder: "Erzählen Sie uns von Ihrer Erfahrung...",
    submit_review: "Bewertung senden",
    sending: "Senden...",
    gdpr_consent: "Mit dem Absenden dieser Bewertung stimmen Sie der Verarbeitung Ihrer personenbezogenen Daten durch {hotel} und Magniflex S.p.A. gemäß der EU-Verordnung 2016/679 (DSGVO) zu, ausschließlich zur Verbesserung des Service. Daten werden nicht an Dritte weitergegeben. Sie können Ihre Rechte ausüben, indem Sie an privacy@magniflex.com schreiben.",
    exclusive_offer: "EXKLUSIVES ANGEBOT",
    take_home_title: "Möchten Sie sie mit nach Hause nehmen?",
    take_home_subtitle: "Hinterlassen Sie Ihre E-Mail und erhalten Sie Ihren persönlichen Rabattcode",
    email_label: "Ihre E-Mail",
    email_placeholder: "name@beispiel.com",
    receive_discount: "Rabatt erhalten",
    no_thanks: "Nein danke",
    error_required_rating: "Bitte wählen Sie eine Bewertung",
    error_email: "Bitte geben Sie eine gültige E-Mail ein",
    coupon_sent_title: "Code gesendet!",
    coupon_sent_subtitle: "Bitte prüfen Sie Ihr Postfach in wenigen Minuten",
    your_coupon: "Ihr Code",
    expires_label: "Gültig bis",
    thanks_title: "Vielen Dank!",
    thanks_subtitle: "Wir schätzen Ihr Feedback sehr",
    showcase_kicker: "Die Matratze, auf der Sie im Hotel geschlafen haben",
    from_price: "Ab",
    free_shipping: "Kostenloser Versand in Italien",
    discover_buy: "Entdecken und kaufen",
    all_sizes_note: "In allen Größen erhältlich · Made in Italy · 10 Jahre Garantie",
    sleep_pleasure: "Schlafen ist das größte Vergnügen",
    select_language: "Sprache",
  },
  fr: {
    how_slept: "Comment avez-vous dormi ?",
    share_experience: "Laissez un commentaire pour recevoir votre coupon",
    rating_label: "Évaluation",
    select_rating: "Veuillez sélectionner une note",
    comment_optional: "Votre commentaire (optionnel)",
    comment_placeholder: "Parlez-nous de votre expérience...",
    submit_review: "Envoyer l'avis",
    sending: "Envoi...",
    gdpr_consent: "En envoyant cet avis, vous consentez au traitement de vos données personnelles par {hotel} et Magniflex S.p.A. conformément au Règlement UE 2016/679 (RGPD), uniquement à des fins d'amélioration du service. Les données ne seront pas cédées à des tiers. Vous pouvez exercer vos droits en écrivant à privacy@magniflex.com.",
    exclusive_offer: "OFFRE EXCLUSIVE",
    take_home_title: "Vous voulez l'emporter chez vous ?",
    take_home_subtitle: "Laissez votre email et recevez votre code de réduction personnel",
    email_label: "Votre email",
    email_placeholder: "nom@exemple.com",
    receive_discount: "Recevoir la réduction",
    no_thanks: "Non merci",
    error_required_rating: "Veuillez sélectionner une note",
    error_email: "Veuillez entrer un email valide",
    coupon_sent_title: "Code envoyé !",
    coupon_sent_subtitle: "Vérifiez votre boîte de réception dans quelques minutes",
    your_coupon: "Votre code",
    expires_label: "Expire le",
    thanks_title: "Merci !",
    thanks_subtitle: "Nous apprécions vraiment votre avis",
    showcase_kicker: "Le matelas sur lequel vous avez dormi à l'hôtel",
    from_price: "À partir de",
    free_shipping: "Livraison gratuite en Italie",
    discover_buy: "Découvrir et acheter",
    all_sizes_note: "Disponible dans toutes les tailles · Fabriqué en Italie · Garantie 10 ans",
    sleep_pleasure: "Dormir est le plus grand des plaisirs",
    select_language: "Langue",
  },
  es: {
    how_slept: "¿Cómo has dormido?",
    share_experience: "Deja un comentario para recibir tu cupón",
    rating_label: "Valoración",
    select_rating: "Por favor selecciona una valoración",
    comment_optional: "Tu comentario (opcional)",
    comment_placeholder: "Cuéntanos tu experiencia...",
    submit_review: "Enviar reseña",
    sending: "Enviando...",
    gdpr_consent: "Al enviar esta reseña aceptas el tratamiento de tus datos personales por parte de {hotel} y Magniflex S.p.A. conforme al Reglamento UE 2016/679 (RGPD), únicamente con fines de mejora del servicio. Los datos no se cederán a terceros. Puedes ejercer tus derechos escribiendo a privacy@magniflex.com.",
    exclusive_offer: "OFERTA EXCLUSIVA",
    take_home_title: "¿Quieres llevártelo a casa?",
    take_home_subtitle: "Deja tu email y recibe tu código de descuento personal",
    email_label: "Tu email",
    email_placeholder: "nombre@ejemplo.com",
    receive_discount: "Recibir el descuento",
    no_thanks: "No gracias",
    error_required_rating: "Por favor selecciona una valoración",
    error_email: "Introduce un email válido",
    coupon_sent_title: "¡Código enviado!",
    coupon_sent_subtitle: "Revisa tu bandeja de entrada en unos minutos",
    your_coupon: "Tu código",
    expires_label: "Caduca el",
    thanks_title: "¡Gracias!",
    thanks_subtitle: "Apreciamos mucho tu opinión",
    showcase_kicker: "El colchón en el que has dormido en el hotel",
    from_price: "Desde",
    free_shipping: "Envío gratuito en Italia",
    discover_buy: "Descubrir y comprar",
    all_sizes_note: "Disponible en todos los tamaños · Hecho en Italia · Garantía de 10 años",
    sleep_pleasure: "Dormir es el mayor placer de la vida",
    select_language: "Idioma",
  },
  zh: {
    how_slept: "您睡得怎么样？",
    share_experience: "留下评论以获取您的优惠券",
    rating_label: "评分",
    select_rating: "请选择评分",
    comment_optional: "您的评论（可选）",
    comment_placeholder: "请告诉我们您的体验...",
    submit_review: "提交评价",
    sending: "发送中...",
    gdpr_consent: "提交此评价即表示您同意 {hotel} 和 Magniflex S.p.A. 根据欧盟法规 2016/679 (GDPR) 处理您的个人数据，仅用于改善服务。数据不会与第三方共享。您可以通过发送邮件至 privacy@magniflex.com 行使您的权利。",
    exclusive_offer: "专属优惠",
    take_home_title: "想把它带回家吗？",
    take_home_subtitle: "留下您的电子邮箱，获取您的专属折扣码",
    email_label: "您的电子邮箱",
    email_placeholder: "name@example.com",
    receive_discount: "获取折扣",
    no_thanks: "不用了",
    error_required_rating: "请选择评分",
    error_email: "请输入有效的电子邮箱",
    coupon_sent_title: "代码已发送！",
    coupon_sent_subtitle: "请在几分钟内查收您的邮箱",
    your_coupon: "您的代码",
    expires_label: "有效期至",
    thanks_title: "谢谢！",
    thanks_subtitle: "我们非常感谢您的反馈",
    showcase_kicker: "您在酒店睡过的床垫",
    from_price: "起价",
    free_shipping: "意大利境内免费送货",
    discover_buy: "了解并购买",
    all_sizes_note: "提供所有尺寸 · 意大利制造 · 10年保修",
    sleep_pleasure: "睡眠是生命中最大的乐趣",
    select_language: "语言",
  },
};

// Rating emojis (creative scale, same as base44 reference)
export const RATING_EMOJIS = ["💀", "⚡", "🏛️", "🔱", "⚜️"];

export function detectLang() {
  const stored = localStorage.getItem("mgx_lang");
  if (stored && translations[stored]) return stored;
  const nav = (navigator.language || "it").slice(0, 2).toLowerCase();
  return translations[nav] ? nav : "it";
}

export function getT(lang) {
  return translations[lang] || translations.it;
}
